import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";

export default function LocationsToDisplay({ children }) {
  return <Box sx={locationsToDisplayStyles}>{children}</Box>;
}

const locationsToDisplayStyles = {
  position: "sticky",
  bottom: "0",
  left: "0",
  right: "0",
  backgroundColor: "#333333",
  color: "white",
  padding: "0.5rem 1rem",
  "& .MuiTypography-root": {
    color: grey[500],
    fontSize: "1rem",
  },
};
